import './App.css';
import Routing from './Utils/Rout';

const App = () => {
  return <Routing />;
};

export default App;
